<div class="app">
  <div class="app__wrapper" [class.anim--in]="!loading">
    <app-topbar [notifications]="$notifications | async" (NotificationClicked)="markNotificationAsRead($event)"></app-topbar>
    <router-outlet class="app__router"></router-outlet>
  </div>

  <app-loader-indicator [loading]="loading"></app-loader-indicator>
</div>
